import { Label } from "react-bootstrap";
import styled from "styled-components";

export const RowHeaderWrapper = styled.div`
    & > div {
        font-weight: 700;
        font-size: 16px;
    }
`;

export const GridWrapper = styled.div`
    height: 76vh;
    width: 100%;

    @media (max-height: 1080px) {
        height: 73vh;
    }

    .ag-header-cell {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        background-color: rgb(19, 51, 102);
        color: #fff;
        font-size: 12px;
    }

    .ag-header-cell > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        font-size: 12px;
        /* padding-bottom: 5px; */
    }

    .ag-header-cell > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ag-header-cell > .ag-react-container > div {
        text-align: center;
        /* padding-bottom: 5px; */
    }

    .ag-cell {
        text-align: center;
        line-height: 36px;
        font-size: 12px;
    }

    .ag-row:hover {
        background-color: #eaf2fa;
    }
    
    
    .left-aligned-tooltip .tooltip-inner {
    text-align: left;
    }
    
    .donor-user-case-load {
        line-height: initial;
        display: flex;
        align-items: center;
    }

    .donor-user-case-load > .ag-react-container {
        width: 100%;
    }

    .donor-drop-down {
        display: flex;
        align-items: center;
    }

    .donor-drop-down > .ag-react-container {
        width: 100%;
    }

    .ag-body-viewport {
        border-left: 1px solid rgb(204, 204, 204);
        border-right: 1px solid rgb(204, 204, 204);
        border-bottom: 1px solid rgb(204, 204, 204);
    }

    .ag-icon {
        color: white;
    }

    .customSortUpLabel,
    .customSortDownLabel {
        margin-left: 3px;
    }

    .ag-cell-value {
        padding-left: 5px;
        padding-right: 5px;
    }
`;

export const TableWrapper = styled.table`
    margin-bottom: 0px;
    
    & > thead > tr {
        background-color: #ddd;
    }

    & > thead > tr > th:nth-child(1) {
        border-left: 1px solid #ddd;
    }

    & > thead > tr > th:last-child {
        border-right: 1px solid #ddd;
    }

    & > thead > tr > th {
        text-align: center;
        border: 1px solid white;
        padding-top: 3px;
        padding-bottom: 3px;
    }

    & > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
        padding-top: 3px;
        padding-bottom: 3px;
    }

    & > thead > tr > th {
        position: sticky;
        top: -1px;
        background-color: #dfe7f1 !important;
    }

    & > thead > tr:nth-child(2) > th {
        position: sticky;
        top: 25px;
        background-color: #dfe7f1 !important;
    }
`;

export const TableWrapperLeftAligned = styled.table`
    // height: 500px;
    
    & > thead > tr {
        background-color: #ddd;
        position: sticky;
        top: 0px;
    }

    & > thead > tr > th:nth-child(1) {
        border-left: 1px solid #ddd;
    }

    & > thead > tr > th:last-child {
        border-right: 1px solid #ddd;
    }

    & > thead > tr > th {
        text-align: left;
        border: 1px solid white;
        padding-top: 3px;
        padding-bottom: 3px;
    }

    & > tbody > tr > td {
        text-align: left;
        padding-top: 3px;
        padding-bottom: 3px;
    }
`;

export const TableBodyWrapper = styled.tbody`
    & > tr > td {
        vertical-align: middle !important
    }
`;

export const LabelWrapper = styled(Label)`
    font-size: 100%;
    padding: 3px 5px;
`;

export const TableWrapperSmall = styled.table`
    margin-bottom: 0px;
    
    & > thead > tr {
        background-color: #ddd;
    }

    & > thead > tr > th:nth-child(1) {
        border-left: 1px solid #ddd;
    }

    & > thead > tr > th:last-child {
        border-right: 1px solid #ddd;
    }

    & > thead > tr > th {
        text-align: center;
        border: 1px solid white;
        padding-top: 3px;
        padding-bottom: 3px;
        font-size: 12px;
    }

    & > tbody > tr > td {
        text-align: center;
        vertical-align: middle;
        padding-top: 3px;
        padding-bottom: 3px;
        font-size: 12px;
    }

    & > thead > tr > th {
        position: sticky;
        top: -1px;
        background-color: #dfe7f1 !important;
    }

    & > thead > tr:nth-child(2) > th {
        position: sticky;
        top: 23px;
        background-color: #dfe7f1 !important;
    }
`;

export const TableWrapperStickyHeader = styled.table`
    & > thead > tr > th,
    & > tbody > tr > td {
        padding: 3px 5px;
    }

    & > thead > tr > th {
        position: sticky;
        top: 0px;
        background-color: #dfe7f1 !important;
    }
`;